// import React from "react";
// import { Navigate } from "react-router-dom";
// import { jwtDecode } from "jwt-decode"; // Correct named import

// // Check if the token is valid (not expired)
// const isTokenValid = () => {
//   const token = localStorage.getItem("authToken");
//   if (!token) return false;

//   try {
//     const decoded = jwtDecode(token);
//      // Correct usage of jwtDecode
//     const currentTime = Date.now() / 1000; // Get current time in seconds
//     return decoded.exp > currentTime; // If token is not expired
//   } catch (error) {
//     console.error("Error decoding token:", error);
//     return false;
//   }
// };

// const PrivateRoute = ({ element }) => {
//   return isTokenValid() ? element : <Navigate to="/login" />;
// };

// export default PrivateRoute;



// // src/helpers/PrivateRoute.jsx
// import React from "react";
// import { Navigate } from "react-router-dom";
// import { jwtDecode } from "jwt-decode"; // Correct import
// import { hasPermission } from "../helpers/permission"; // Your helper to check permission
// import { showToast } from "../components/toast.jsx"; // Toast helper

// // Check if the token is valid
// const isTokenValid = () => {
//   const token = localStorage.getItem("authToken");
//   if (!token) return false;

//   try {
//     const decoded = jwtDecode(token);
//     const currentTime = Date.now() / 1000;
//     return decoded.exp > currentTime;
//   } catch (error) {
//     console.error("Error decoding token:", error);
//     return false;
//   }
// };

// const PrivateRoute = ({ element, module, action = "view" }) => {
//   // Token must be valid
//   if (!isTokenValid()) return <Navigate to="/login" />;

//   // Permission check
//   // if (module && !hasPermission(module, action)) {
//   //   // Show toast before redirecting
//   //   showToast.error("You Don't Have Enough Permission To Access This Section.");
//   //   return <Navigate to="/dashboard" replace />;
//   // }
//   if (module && !hasPermission(module, action)) {
//     // Redirect with toast parameter
//     return <Navigate to="/dashboard?toast=permission_denied" replace />;
//   }

//   return element;
// };

// export default PrivateRoute;


// // src/helpers/PrivateRoute.jsx
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { hasPermission, initializePermissions, isPermissionsInitialized } from "../helpers/permission";
import { showToast } from "../components/toast.jsx";

const PrivateRoute = ({ element, module, action = "view" }) => {
  const [ready, setReady] = useState(isPermissionsInitialized());

  useEffect(() => {
    if (!ready) {
      // Wait for permissions to initialize
      initializePermissions().then(() => setReady(true));
    }
  }, [ready]);

  // While waiting for permissions, don't render anything
  if (!ready) return null; // You can replace with a spinner if needed

  // Token check (unchanged)
  const token = localStorage.getItem("authToken");
  if (!token) return <Navigate to="/login" />;

  // Permission check
  if (module && !hasPermission(module, action)) {
    return <Navigate to="/dashboard?toast=permission_denied" replace />;
  }

  return element;
};

export default PrivateRoute;
